import React from 'react';

function SiteDeactivated({ siteName, suspendReason }) {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="mb-6">
          <svg 
            className="mx-auto h-16 w-16 text-amber-500" 
            fill="none" 
            viewBox="0 0 24 24" 
            stroke="currentColor"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
            />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-4">
          Site Deactivated
        </h1>
        
        <p className="text-gray-600 mb-6">
          {siteName ? (
            <>
              <span className="font-medium">{siteName}</span> has been deactivated.
            </>
          ) : (
            'This site has been deactivated.'
          )}
        </p>
        
        {suspendReason && (
          <p className="text-sm text-gray-500 mb-6 bg-gray-50 p-3 rounded">
            Reason: {suspendReason}
          </p>
        )}
        
        <div className="border-t border-gray-200 pt-6">
          <p className="text-gray-600 mb-4">
            Please contact your cemetery administrator or reach out to support for assistance.
          </p>
          
          <a 
            href="mailto:support@parishrecorder.com"
            className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white font-medium rounded-md hover:bg-indigo-700 transition-colors"
          >
            <svg 
              className="w-5 h-5 mr-2" 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" 
              />
            </svg>
            Contact Support
          </a>
          
          <p className="mt-4 text-sm text-gray-500">
            support@parishrecorder.com
          </p>
        </div>
      </div>
      
      <div className="mt-8 text-center text-sm text-gray-500">
        <p>Powered by Parish Recorder</p>
      </div>
    </div>
  );
}

export default SiteDeactivated;
